export default "__VITE_PUBLIC_ASSET__1e9b6b3b__"